import { Box, Typography } from "@material-ui/core";
import paginationFactory from "react-bootstrap-table2-paginator";

const DEFAULT_PAGE_SIZE = 25;
const DEFAULT_PAGE_OPTIONS = [25, 50, 100];

export default function TablePagination({
  paginationOptions,
  dataLength,
  selectRef,
}) {
  if (!paginationOptions) return null;

  const {
    options = DEFAULT_PAGE_OPTIONS,
    defaultOption = DEFAULT_PAGE_SIZE,
    sizePerPage = DEFAULT_PAGE_SIZE,
    ...restPagination
  } = paginationOptions;

  return paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: false,
    withFirstAndLast: false,
    sizePerPage: sizePerPage,
    nextPageTitle: "próxima página",
    prePageTitle: "página anterior",
    firstPageTitle: "Primeira página",
    lastPageTitle: "Última página",
    paginationTotalRenderer: (from, to, size) => (
      <Box>
        <Typography variant="caption">
          Exibindo {from} até {to} de {size}{" "}
          {size === 1 ? "resultado" : "resultados"}
        </Typography>
      </Box>
    ),
    sizePerPageRenderer: ({ onSizePerPageChange }) => (
      <Box>
        <Typography variant="caption">
          Mostrar{" "}
          <select
            ref={selectRef}
            aria-label="Selecione a quantidade de registros por página"
            onClick={(e) => {
              if (!e.isTrusted) {
                onSizePerPageChange(e.target.value);
              }
            }}
            onChange={(e) => onSizePerPageChange(e.target.value)}
            value={sizePerPage}
          >
            {options?.map((option, index) => (
              <option key={`page-size-${index}`} value={option}>
                {option}
              </option>
            ))}
            <option key="all" hidden value={dataLength}>
              Todos
            </option>
          </select>{" "}
          registros.
        </Typography>
      </Box>
    ),
    ...restPagination,
  });
}
